import React from 'react'
import { FlexAlign } from '../../Flex'
import { FlexButtonGroupDiv } from './FlexButtonGroup.styles'

type FlexButtonGroupProps = {
  num: number
  children: JSX.Element | JSX.Element[]
  align?: FlexAlign
}

export const FlexButtonGroup = ({
  num,
  children,
  align,
}: FlexButtonGroupProps): JSX.Element => (
  <FlexButtonGroupDiv num={num} $align={align}>
    {children}
  </FlexButtonGroupDiv>
)
